import * as React from 'react';
import PageJumpToolHeader from './PageJumpToolHeader';
import PageJumpToolPanel from './PageJumpToolPanel';

interface PageJumpToolProps {
  onCloseButtonClick:() => void;
}

const frameStyle: React.CSSProperties = {
  width: '212px',
  background: '#575757',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  borderRadius: '3px',
};

export default class PageJumpTool extends React.PureComponent<PageJumpToolProps> {
  public render() {
    const { onCloseButtonClick } = this.props;

    return (
      <div style={frameStyle} >
        <PageJumpToolHeader onCloseButtonClick={onCloseButtonClick}/>
        <PageJumpToolPanel />
      </div>
    );
  }
}
